import React from 'react';
import { Bell } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface UnreadIndicatorProps {
  className?: string;
}

const UnreadIndicator: React.FC<UnreadIndicatorProps> = ({ className = '' }) => {
  return (
    <div
      className={twMerge(
        'relative w-10 h-10 rounded-full flex items-center justify-center',
        className
      )}
    >
      <Bell className="w-5 h-5 text-secondary" />
      <span className="absolute -top-0.5 -right-0.5 bg-primary text-white text-xs rounded-full px-2 py-0.5 md:-top-0.5 md:-right-0">
        !
      </span>
    </div>
  );
};

export default UnreadIndicator;
